import { apiClient } from './client';

export interface Waybill {
  id: number; waybill_reference: string; origin: string; destination: string; vehicle_id: number | null; driver_employee_id: number | null;
  dispatch_date: string; status: string; recipient_name: string; transported_by: string | null; received_by_name: string | null;
  received_date: string | null; received_condition: string | null; notes: string | null;
}
export interface WaybillItem { id: number; description: string; quantity: string; unit: string | null; condition_notes: string | null; quantity_received: string | null; shortage_quantity: string; damage_quantity: string; }

export const waybillsApi = {
  list: () => apiClient.get<{ data: Waybill[] }>('/api/waybills'),
  get: (id: number) => apiClient.get<{ data: Waybill }>(`/api/waybills/${id}`),
  listItems: (id: number) => apiClient.get<{ data: WaybillItem[] }>(`/api/waybills/${id}/items`),
  create: (input: Record<string, unknown>) => apiClient.post<{ data: { id: number; waybillReference: string } }>('/api/waybills', input),
  addItem: (id: number, input: Record<string, unknown>) => apiClient.post<{ data: { id: number } }>(`/api/waybills/${id}/items`, input),
  setStatus: (id: number, status: string) => apiClient.put<{ data: { id: number; status: string } }>(`/api/waybills/${id}/status`, { status }),
  recordReceipt: (id: number, input: { receivedByName: string; receivedDate: string; condition: string }) =>
    apiClient.post<{ data: { id: number } }>(`/api/waybills/${id}/receipt`, input),
  recordItemReceipt: (itemId: number, input: { quantityReceived: number; shortageQuantity?: number; damageQuantity?: number }) =>
    apiClient.put<{ data: { id: number } }>(`/api/waybill-items/${itemId}/receipt`, input),
};
